export default <T>(item: T | undefined | null): item is T =>
  item !== undefined && item !== null;
